module.exports = __webpack_public_path__ + "assets/images/novasports_extra2.e9ec2d5bfd02c45a29b765c2ecd5d737.png";